import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "variant", "size"];
var __jsx = React.createElement;
import * as React from "react";
import { cn } from "@/common/lib/utils";
var buttonVariants = function buttonVariants() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "primary";
  var variants = {
    primary: "bg-primary text-primary-foreground hover:bg-primary/90 border-none cursor-pointer",
    secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80 border-none cursor-pointer",
    ghost: "hover:bg-accent hover:text-accent-foreground border-none bg-transparent cursor-pointer hover:bg-[#F1F6FC] transition-colors ease-in bg-white rounded-full !ring-offset-0 text-primary-new",
    outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground border-none cursor-pointer"
  };
  return cn("inline-flex items-center justify-center rounded-full text-sm font-medium transition-colors", "disabled:pointer-events-none disabled:opacity-50 disabled:text-[#B0B0B0]", variants[variant]);
};
var sizeVariants = function sizeVariants() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
  var sizes = {
    "default": "h-10 px-4 py-2",
    sm: "h-9 rounded-md px-3",
    lg: "h-11 rounded-md px-8",
    icon: "h-10 w-10"
  };
  return sizes[size];
};
var CalendarButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "primary" : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "default" : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: ref,
    className: cn(buttonVariants(variant), sizeVariants(size), className)
  }, props));
});
CalendarButton.displayName = "CalendarButton";
export { CalendarButton, buttonVariants };